import Component from "../../lib/component";

export const SelecterFilterInfoConfig = {
    componentTypeKey: 'SelecterFilterInfo',
    baseHtmlClass: 'selector__filter__info',
    selector: '.selector__filter__info',
};

export class SelecterFilterInfo extends Component {

    static createElement() {
        let element = document.createElement('div');
        element.classList.add(SelecterFilterInfoConfig.baseHtmlClass);
        return element;
    }

    constructor(id_or_element, selecter) {
        super({
            element: id_or_element,
            config: SelecterFilterInfoConfig
        });

        this.selecter = selecter;
    }

    render() {
        let content = '';
        const itemsCount = this.getTotalItemsCount();
        const matchedItemsCount = this.getMatchedItemsCount();
        if (itemsCount === matchedItemsCount) {
            content = `<p>Showing all ${ itemsCount } items</p>`;
        } else {
            content = `<p>Showing ${ matchedItemsCount } of ${ itemsCount } items</p>`;
        }
        this.element.innerHTML = content;
    }

    getTotalItemsCount() {
        return this.selecter.getTotalItemsCount();
    }

    getMatchedItemsCount() {
        return this.selecter.getMatchedItemsCount();
    }


}

